import React from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Balance from '../../../../assets/balance.svg';
import * as urls from '../../../../urls';
import Styles from './index.module.scss';
import { checkPrivileges, checkSubaccount } from '../../../../utils';
import { Tooltip } from '@kaleyra/emmy';
import { enterpriseCustomerTypeId, resellerCustomerTypeId, subaccountFlag } from '../../../../constants';
import { useSelector } from 'react-redux';
import { IStateType } from '../../../../store/models/root.interface';
import Info from '../../../../assets/infoIconBlack.svg';
import { REDIRECT_URL } from '../../../../base';

export type MapStatePropsType = {
	isPostpaid: number;
	baseCurrencyVal: number;
	maxPostpaidLimit: number;
	baseCurrencySymbol: string;
};

export type DispatchPropsType = {
	setDataLayerInfo: () => void;
};

const BalanceButton: React.FC<MapStatePropsType & DispatchPropsType> = ({
	isPostpaid,
	baseCurrencySymbol,
	baseCurrencyVal,
	maxPostpaidLimit,
	setDataLayerInfo,
}) => {
	const { t } = useTranslation();
	const { customer_type_id: customerTypeID, credit_type, monthly_limit } = useSelector((state: IStateType) => state.profile?.fullProfile);
	const { assigned , is_subaccount_no_limit , subaccount_usage} = useSelector((state: IStateType) => state.balance?.fullBalanceObject);

	let assignedAmount = parseFloat(assigned);

	React.useEffect(() => {
		setDataLayerInfo();
	}, [baseCurrencyVal]);

	const getCurrencyValue = (): string => {
		const ammount = (isPostpaid
			? maxPostpaidLimit - (baseCurrencyVal + assignedAmount)
			: baseCurrencyVal
		).toLocaleString(undefined, {
			minimumFractionDigits: 2,
			maximumFractionDigits: 2,
		});
		return is_subaccount_no_limit ? `${baseCurrencySymbol}${Number(subaccount_usage).toFixed(2)}`:`${baseCurrencySymbol}${ammount}`;
	};
	const getToolTipTitle = () => {

		if (credit_type.includes('assigned') && credit_type.length === 1) {
			return t("KLR02657");
		}
		if (credit_type.includes('shared') && monthly_limit === '0') {
			return t("KLR02738");
		}
		if (credit_type.includes('shared') && monthly_limit === '1') {
			return t("KLR02739");
		}
		return '';
	};

	return (
		<>
			{checkPrivileges('prices', 'main') ?
				<>
					{!isPostpaid ?
						<a href={REDIRECT_URL + '/billing'} className={checkPrivileges('billing', 'topup') ? Styles.balance : Styles.balanceHidden}>
							{`${t('mainBalance')}: `}
							<span>{getCurrencyValue()}</span>
							{checkPrivileges('billing', 'topup') &&
								<img src={Balance} alt="balance" />
							}
						</a>
						:
						<Tooltip
							title={(enterpriseCustomerTypeId.includes(customerTypeID) || resellerCustomerTypeId.includes(customerTypeID)) && subaccountFlag === 'true' ?
								<div style={{ fontSize: 12 }}>{getToolTipTitle()}</div> : null}
							overlayInnerStyle={{ borderRadius: "4px", width: 190 }} >
							<NavLink to={urls.v1Billing({ tab: 'usage' })} className={checkPrivileges('billing', 'usage') ? Styles.balance : Styles.balanceHidden}>
								{`${t('mainUsage')}: `}
								<span>{getCurrencyValue()}</span>
								{(enterpriseCustomerTypeId.includes(customerTypeID) || resellerCustomerTypeId.includes(customerTypeID)) && subaccountFlag === 'true' && <img src={Info} className={Styles.infoImg} />}
							</NavLink>
						</Tooltip>
					}
				</>
				: null}
		</>
	);
};

export default BalanceButton;
